import dayjs from 'dayjs';
import { NULL_VALUE } from 'constants/displayConstants';
import { getLatLongFromGeometry } from '../../LayersTab/utils/getLatLongFromGeometry';
import { isExerciseType } from './isExerciseType';
import type { IncidentListItemData } from '../IncidentListItem';
import type { Incident } from 'components/IAP/hooks/incidentHooks';

const INCIDENT_CREATED_AT_FORMAT = 'MMMM D, YYYY HH:mm';

export function buildIncidentListItems({
  incidents,
  aorNameById,
}: {
  incidents: Incident[];
  aorNameById: Map<string, string>;
}): IncidentListItemData[] {
  return incidents
    .filter((incident) => !(incident.incident_types ?? []).some(isExerciseType))
    .map((incident) => {
      const aorIds = incident.areas_of_responsibility ?? [];
      const aor =
        aorIds.map((aorId) => aorNameById.get(aorId) || aorId).join(', ') ||
        NULL_VALUE;

      const { location } = incident;
      const latLong = location ? getLatLongFromGeometry(location) : null;

      return {
        id: incident.id,
        name: incident.name,
        incidentTypes: (incident.incident_types ?? []).filter(
          (type) => !isExerciseType(type)
        ),
        currentPeriodId: incident.current_period,
        aor,
        aorIds,
        createdAt: dayjs(incident.incident_created).format(
          INCIDENT_CREATED_AT_FORMAT
        ),
        latLong,
        locationGeometry: location ?? null,
      };
    });
}
